import { useState, useEffect } from 'react';
import { getVisitorUUID } from '../utils/uuidManager';

export const useVisitorId = () => {
  const [visitorId, setVisitorId] = useState(null);

  useEffect(() => {
    const fetchVisitorId = async () => {
      try {
        const uuid = await getVisitorUUID();
        setVisitorId(uuid);
      } catch (error) {
        console.error('Error fetching visitor ID:', error);
      }
    };

    // Initial fetch
    fetchVisitorId();

    // Listen for storage changes
    const handleStorageChange = (e) => {
      if (e.key === 'visitorUUID') {
        fetchVisitorId();
      }
    };

    // Listen for custom UUID update event
    const handleUUIDUpdate = () => {
      fetchVisitorId();
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('uuidUpdated', handleUUIDUpdate);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('uuidUpdated', handleUUIDUpdate);
    };
  }, []);

  return visitorId;
}; 